module.exports = __webpack_public_path__ + "static/media/0_2018_12_26.64c1682f.jpg";